// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signatureHolder {
    background: transparent !important;
}

.buttonBox {
    position: absolute;
    right: 0px;
    bottom: 0px;
    color: initial;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/signaturepad/signature.pad.control.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;AAClB","sourcesContent":[".signatureHolder {\n    background: transparent !important;\n}\n\n.buttonBox {\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    color: initial;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
